module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACXSURBVHgB7ZDNDYJQEIRneK8ASrAE7cQTerOVZyV61GrQCqQEChAeGxLCT0Ig7CPhwHfZ7B5mZ4YmSc8gHwBi6Mjg6Wgun58sB4Qht41Y8T4SCsSYlxFHCIwd+TSbYbL1HWq73CNPR556uP3I6zk0yfcG+icUSPlZ61Avlhv6e69DyuH/OjkspESnQ61YQxRSrMZeU4eAVBiqNddLMbQTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/data.png
// module id = DdzE
// module chunks = 1